import _defineProperty from '@babel/runtime/helpers/defineProperty';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var sizes = [0, 1, 2, 4, 8, 12, 16, 24, 32, 40, 48, 56, 64, 72, 80, 88, 96, 104, 112, 120];
var unit = "rem";
var fontBase = 16;
var spacing = sizes.reduce(function (acc, cur) {
  return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, cur, "".concat(cur / fontBase).concat(unit)));
}, {});
var pixelToRem = function pixelToRem(px) {
  return "".concat(px / fontBase).concat(unit);
};
var toUnitlessLineHeight = function toUnitlessLineHeight(lineHeight, fontSize) {
  return "".concat((lineHeight / fontSize).toFixed(3));
};

export { fontBase, pixelToRem, sizes, spacing, toUnitlessLineHeight };
//# sourceMappingURL=spacing.esm.js.map
